export default "/assets/images/mila-feed-05.mp4?24f3d36ab74ff3ff211a4e1605c45ab6";